import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { succsesDataAddAlert } from "../../alerts/alerts";
import ModalAddComment from "../../components/modals/modalAddComent/ModalAddComment";
import ProductsSearchList from "../../components/searchList/ProductsSearchList";
import SearchList from "../../components/searchList/SearchList";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useGetPageUnloadQuery } from "../../redux/services/noLoadingReqAPI";
import SaveBtn from "../../components/saveBtn/SaveBtn";

const Repair = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const searchClientRef = useRef();
    const searchProductRef = useRef();
    const inputClientRef = useRef();
    const inputImeitRef = useRef();

    const [showSearchClientList, setShowSearchClientList] = useState(false);
    const [showSearchImeiList, setShowSearchImeiList] = useState(false);
    const [showCommentModal, setShowCommentModal] = useState(false);

    const [deviceType, setDeviceType] = useState("");
    const [device, setDevice] = useState("");
    const [imei, setImei] = useState("");
    const [productId, setProductId] = useState(0);
    const [pincode, setPincode] = useState("");
    const [damage, setDamage] = useState("");
    const [assembly, setAssembly] = useState("");
    const [view, setView] = useState("");
    const [noteMaster, setNoteMaster] = useState("");
    const [isWarranty, setIsWarranty] = useState(0);
    const [storeId, setStoreId] = useState(0);
    const [repairTime, setRepairTime] = useState("");
    const [clientName, setClientName] = useState("");
    const [clientCard, setClientCard] = useState("");
    const [clientPhone, setClientPhone] = useState("");
    const [clientId, setClientId] = useState("");
    const [price, setPrice] = useState(0);
    const [noteClient, setNoteClient] = useState("");
    const [repairStatusId, setRepairStatusId] = useState("");
    const [comments, setComments] = useState("");
    const [addedComents, setAddedComments] = useState([]);
    const [productOrderDate, setProductOrderDate] = useState(0);

    const { data: repairStatuses } = useGetPageQuery("repair-statuses");
    const { data: clients } = useGetPageUnloadQuery("clients?per_page=6&search=" + clientName);
    const { data: products } = useGetPageUnloadQuery("products?per_page=6&is_sold=1&search=" + imei);
    const [sendForm, { isLoading, isError }] = useSendFormMutation();
    const { data: stores } = useGetPageQuery("stores?permission=repair&per_page=100");

    const sendFormHandler = async () => {
        const formData = {
            device_type: deviceType,
            device: device,
            imei: imei,
            product_id: productId,
            pincode: pincode,
            damage: damage,
            assembly: assembly,
            view: view,
            note_master: noteMaster,
            is_warranty: isWarranty,
            store_id: storeId,
            repair_time: repairTime,
            client_name: clientName,
            client_card: clientCard,
            client_phone: clientPhone,
            client_id: clientId,
            price: price,
            note_client: noteClient,
            repair_status_id: repairStatusId,
            comments: addedComents,
        };

        await sendForm({ body: formData, url: "repairs", method: "POST" }).unwrap();
        navigate("/repairs");

        // if (!isError) {
        //     succsesDataAddAlert();
        //     navigate("/repairs");
        // }
    };

    const onSelectClientHandler = (client) => {
        setClientId(client.id);
        setClientName(client.name);
        setClientPhone(client.phone);
        setClientCard(client.card);
        setShowSearchClientList(false);
    };

    const onSelectProductHandler = (product) => {
        setDevice(product.title);
        setImei(product.imei_sn);
        setProductId(product.id);
        setShowSearchImeiList(false);
        setIsWarranty(0);
        setProductOrderDate(product?.orders[0]?.created_at ?? 0);
    };

    useEffect(() => {
        const outsideHandleClick = (e) => {
            if (
                searchClientRef.current &&
                !e.composedPath().includes(searchClientRef.current) &&
                inputClientRef.current &&
                !e.composedPath().includes(inputClientRef.current)
            ) {
                setShowSearchClientList(false);
            }
            if (
                inputImeitRef.current &&
                !e.composedPath().includes(inputImeitRef.current) &&
                searchProductRef.current &&
                !e.composedPath().includes(searchProductRef.current)
            ) {
                setShowSearchImeiList(false);
            }
        };

        document.body.addEventListener("click", outsideHandleClick);

        return () => {
            document.body.removeEventListener("click", outsideHandleClick);
        };
    }, []);

    const addCommentHandler = (comment) => {
        setAddedComments([...addedComents, { text: comment }]);
        setShowCommentModal(false);
    };

    useEffect(() => {
        if (repairStatuses && stores) {
            setStoreId(stores.data[0].id);
            setRepairStatusId(repairStatuses[0].id);
        }
    }, [repairStatuses, stores]);

    const setWarrantyHandler = (isWarranty) => {
        const currentDate = new Date();
        const productDate = new Date(moment(productOrderDate).format("YYYY-MM-DD"));

        const timeDifference = currentDate.getTime() - productDate.getTime();
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        if (productOrderDate === 0) {
            alert("Товар не був проданий");
        } else if (daysDifference < 31) {
            setIsWarranty(isWarranty);
        } else {
            setIsWarranty(0);
            alert("Срок гарантії 31 день пройшов");
        }
    };

    return (
        <>
            {stores && clients && repairStatuses && (
                <div className="content">
                    <ModalAddComment
                        showCommentModal={showCommentModal}
                        setShowCommentModal={setShowCommentModal}
                        addCommentHandler={addCommentHandler}
                    />
                    <SaveBtn
                        isLoading={isLoading}
                        onBtnClick={sendFormHandler}
                    />
                    <div className="col-12">
                        <form
                            id="float_save"
                            className="form"
                            method="post"
                        />
                        <div className="d-flex align-items-center">
                            <div className="float-start">
                                <h1>Додати ремонт</h1>
                            </div>
                            <div className="float-start">
                                <select
                                    className="form-select mx-2"
                                    value={repairStatusId}
                                    onChange={(e) => setRepairStatusId(e.target.value)}
                                >
                                    {repairStatuses.map((status) => {
                                        return (
                                            <option
                                                key={status.id}
                                                value={status.id}
                                            >
                                                {status.title}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <input
                            type="hidden"
                            name="id"
                        />
                        <input
                            type="hidden"
                            name="product_id"
                        />
                        <input
                            type="hidden"
                            name="shipper_id"
                        />
                        <div className="row">
                            <div className="col-12 col-sm-6 col-lg-6">
                                <div className="card card-default">
                                    <div className="card-header d-flex justify-content-between">
                                        Інформація про пристрій
                                        <div className="custom-control custom-checkbox float-right">
                                            <input
                                                className="form-check-input mx-2"
                                                type="checkbox"
                                                checked={isWarranty}
                                                onChange={(e) => setWarrantyHandler(+e.target.checked)}
                                            />
                                            <label className="custom-control-label">Гарантійний ремонт</label>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <label className="form-label">Тип пристрою</label>
                                            <input
                                                className="form-control"
                                                name="device_type"
                                                maxLength="255"
                                                type="text"
                                                value={deviceType}
                                                onChange={(e) => setDeviceType(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Пристрій</label>
                                            <input
                                                className="form-control"
                                                name="device"
                                                maxLength="255"
                                                type="text"
                                                value={device}
                                                onChange={(e) => setDevice(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">IMEI</label>
                                            <input
                                                className="form-control "
                                                ref={inputImeitRef}
                                                maxLength="255"
                                                type="text"
                                                autoComplete="off"
                                                value={imei}
                                                onChange={(e) => setImei(e.target.value)}
                                                onFocus={() => setShowSearchImeiList(true)}
                                            />
                                            <div ref={searchProductRef}>
                                                {showSearchImeiList && (
                                                    <ProductsSearchList
                                                        products={products.data}
                                                        onSelectProductHandler={onSelectProductHandler}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Код розблокування</label>
                                            <input
                                                className="form-control"
                                                name="pin_code"
                                                maxLength="255"
                                                type="text"
                                                value={pincode}
                                                onChange={(e) => setPincode(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Пошкодження</label>
                                            <textarea
                                                name="damage"
                                                className="form-control"
                                                value={damage}
                                                onChange={(e) => setDamage(e.target.value)}
                                            ></textarea>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-sm-6 col-lg-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Комплектація</label>
                                                    <textarea
                                                        name="stock"
                                                        className="form-control"
                                                        value={assembly}
                                                        onChange={(e) => setAssembly(e.target.value)}
                                                    ></textarea>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-lg-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Вигляд</label>
                                                    <textarea
                                                        name="view"
                                                        className="form-control"
                                                        value={view}
                                                        onChange={(e) => setView(e.target.value)}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Примітка майстра</label>
                                            <textarea
                                                name="master_note"
                                                className="form-control"
                                                value={noteMaster}
                                                onChange={(e) => setNoteMaster(e.target.value)}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="card card-default">
                                    <div className="card-header d-flex justify-content-between">
                                        Коментарі
                                        <div className="float-right">
                                            <div
                                                className="add-comment__button"
                                                onClick={() => setShowCommentModal(true)}
                                            >
                                                Додати
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="card-body"
                                        style={{ height: "295px", overflowY: "auto" }}
                                    >
                                        {comments.length > 0 ? (
                                            <table className="table table-striped">
                                                <tbody>
                                                    {comments.map((comment) => {
                                                        return (
                                                            <tr key={comment.id}>
                                                                <td>
                                                                    <div>
                                                                        {comment.text}{" "}
                                                                        <span className="float-end">
                                                                            {moment(comment.created_at).format(
                                                                                "DD.MM.YYYY HH:MM"
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                    <div>gg</div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="alert alert-info">
                                                {addedComents.length > 0 ? "Коментар додано" : "Коментарі відсутні"}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-6">
                                <div className="card card-default">
                                    <div className="card-header d-flex justify-content-between">
                                        <span className="float-right"></span>
                                    </div>
                                    <div className="card-body">
                                        <div className="mb-3">
                                            <label className="form-label">Магазин</label>
                                            <select
                                                name="store_id"
                                                className="form-control custom-select"
                                                value={storeId}
                                                onChange={(e) => setStoreId(e.target.value)}
                                            >
                                                {stores.data.map((store) => {
                                                    return (
                                                        <option
                                                            value={store.id}
                                                            key={store.id}
                                                        >
                                                            {store.title}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Час на ремонт</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="date_end"
                                                value={repairTime}
                                                onChange={(e) => setRepairTime(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Клієнт </label>
                                            <input
                                                ref={inputClientRef}
                                                className="form-control"
                                                maxLength="255"
                                                type="text"
                                                placeholder="Проскануйте карту або почніть вводити Імя"
                                                autoComplete="off"
                                                value={clientName}
                                                onChange={(e) => setClientName(e.target.value)}
                                                onFocus={() => setShowSearchClientList(true)}
                                                // onBlur={() => setShowSearchClientList(false)}
                                            />
                                            <div ref={searchClientRef}>
                                                {showSearchClientList && (
                                                    <SearchList
                                                        clients={clients.data}
                                                        onSelectClientHandler={onSelectClientHandler}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Карта клієнта</label>
                                            <input
                                                className="form-control"
                                                name="client_card"
                                                id="client_card"
                                                maxLength="255"
                                                type="text"
                                                value={clientCard}
                                                onChange={(e) => setClientCard(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Телефон клієнта</label>
                                            <input
                                                className="form-control"
                                                name="client_phone"
                                                maxLength="255"
                                                type="text"
                                                value={clientPhone}
                                                onChange={(e) => setClientPhone(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Ціна ремонту</label>
                                            <input
                                                className="form-control"
                                                name="price"
                                                maxLength="255"
                                                type="text"
                                                value={price}
                                                onChange={(e) => setPrice(e.target.value)}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Примітка клієнта</label>
                                            <textarea
                                                name="note"
                                                className="form-control"
                                                value={noteClient}
                                                onChange={(e) => setNoteClient(e.target.value)}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {permissions.includes("all") || permissions.includes("repair_view") ? (
                                <div className="saves_block">
                                    <button
                                        name="user_info"
                                        className="btn btn-primary"
                                        onClick={sendFormHandler}
                                    >
                                        {isLoading ? "Завантаження" : "Зберегти"}
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Repair;
